import { service } from '@ember/service';
import Component from '@glimmer/component';
import AccountMenu from 'garaje/components/account-menu';
import type StateService from 'garaje/services/state';

interface VisitorsStickyContextHeaderSignature {
  Args: {
    /** Optional bold title line above the company/location (e.g. "Approval request"). */
    title?: string;
  };
  Element: HTMLDivElement;
}

// Phone-only sticky bar showing the current company and location (stands in for the hidden nav).
export default class VisitorsStickyContextHeader extends Component<VisitorsStickyContextHeaderSignature> {
  @service declare state: StateService;

  <template>
    <div
      class="sm:hidden sticky top-0 z-20 -mx-4 -mt-4 flex items-center gap-3 border-b border-carbon-10 bg-white px-4 py-3"
      data-test-sticky-context-header
      ...attributes
    >
      <img
        src="/assets/images/logo-small-red.svg"
        alt=""
        role="presentation"
        width="28"
        height="28"
        class="h-7 w-7 shrink-0"
      />
      <div class="min-w-0">
        {{#if @title}}
          <p class="mb-0 text-base font-bold leading-tight text-carbon-90" data-test-sticky-title>{{@title}}</p>
        {{/if}}
        <p class="mb-0 truncate text-sm leading-tight text-carbon-50">
          {{this.state.currentCompany.name}}
          <span aria-hidden="true">·</span>
          {{this.state.currentLocation.name}}
        </p>
      </div>
      <AccountMenu class="ml-auto shrink-0" />
    </div>
  </template>
}
